import styled from '@emotion/styled';
import React from 'react';
import { RadioTile } from 'basis';

export const ButtonToggleWrapper = styled.div`
  ${props => {
    const buttonColor = props.theme?.primaryButtonColor;
    const borderColor = props.theme?.achRadioButtonColor;
    return `
    div[role="radiogroup"] {
      border-radius: 4px;
      border: 1px solid ${borderColor};
      width: 350px;
      & > div {
        grid-column-gap: 0;
      }

      & > div > div:first-child {
        div[role="radio"] {
          border-right: 1px solid ${borderColor};
        }
      }

      ${`@media (max-width: ${props.theme.screenSize?.md})`} {
        width: 100%;
      }
    }

    div[role="radiogroup"]:has(+ div) {
      border: 1px solid ${props.theme?.colors?.conditional?.negative?.graphics ?? '#cf000f'};
      & > div > div:first-child {
        div[role="radio"] {
          border-right: 1px solid ${props.theme?.colors?.conditional?.negative?.graphics ?? '#cf000f'};
        }
      }
    }

    div[role="radiogroup"] + div {
      border: 0;
    }

    &:has(input:checked) {
      & div[role="radio"] {
        border-right: 0 !important;
      }
    }

    label {
      height: auto;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      background: white;
      margin: 5px;
      color: ${borderColor};
      border-radius: 4px;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      line-height: 20px;
      padding: 10px 5px;

      &:hover {
        background-color: #E6EFFD;
      }
    }

    input:checked + label {
      background: ${buttonColor};
      color: ${borderColor}

      &:hover {
        background-color: #004AB6;
      }
    }

    svg {
      display: none;
    }
  `;
  }}
`;

export const ButtonToggle = ({ ...props }) => {
  return <RadioTile {...props} columns={2} />;
};
